import sanitizeContent from '../services/sanitize-content';

export const CREATE_POST_REQUEST = 'post/CREATE_REQUEST';
export const CREATE_POST_SUCCESS = 'post/CREATE_SUCCESS';
export const CREATE_POST_FAILURE = 'post/CREATE_FAILURE';

export function createPost(post = {}) {
  return (dispatch, getState, { request }) => {
    dispatch({
      type: CREATE_POST_REQUEST,
    });

    const promise = request.post(`/_api/posts/`, sanitizeContent(post));

    return promise
      .then(post =>
        dispatch({
          type: CREATE_POST_SUCCESS,
          payload: post,
        })
      )
      .catch(() =>
        dispatch({
          type: CREATE_POST_FAILURE,
        })
      )
      .then(() => promise);
  };
}



// WEBPACK FOOTER //
// ./app/actions/create-post.js